import React from 'react';
import { Button } from '@zurich-primitives/button';
import { Modal } from '@zurich-base-ui/components.modal';
import {
  getBetaWelcomeModal,
  useAppSelector,
  setBetaWelcomeModal,
  useAppDispatch
} from 'app/redux';
import BetaWelcomePictogram from 'app/assets/Pictograms/BetaWelcome.svg';
import styles from './BetaWelcome.module.scss';

const BetaWelcome: React.FC = () => {
  const dispatch = useAppDispatch();
  const isBetaWelcome: boolean = useAppSelector(getBetaWelcomeModal);

  const hadnleOnClose = (): void => {
    dispatch(setBetaWelcomeModal(false));
    localStorage.setItem('welcomeModal', 'false');
  };

  return (
    <Modal on={isBetaWelcome} onClose={hadnleOnClose} variant="slim">
      <div className={`${styles.modal} p-8 pt-6`}>
        <h2 className="f-data-blue highlight">
          Welcome to our beta
          <br />
          version portal!
        </h2>
        <img
          src={BetaWelcomePictogram}
          alt="Welcome to the beta version"
          className={styles.pictogram}
          aria-hidden
        />
        <p className="caption-lg-r">
          Enjoy the free exploration and usage of our platform as we continue to
          develop and enhance its features, with costs anticipated in future
          versions.
        </p>
        <Button onClick={hadnleOnClose} className={styles['ok-btn']}>
          Ok
        </Button>
      </div>
    </Modal>
  );
};

export default BetaWelcome;
